import { Record, Map } from 'immutable';

const PhotoRecord = Record({
  id: undefined,
  createdAt: undefined,
  defaultImage: undefined,
  originalImage: undefined,
  squareTemplateHref: undefined,
  _links: new Map(),
  _forms: new Map()
});

class Photo extends PhotoRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default Photo;


// WEBPACK FOOTER //
// ./src/api/models/photo.js